import React from 'react';
import {
  Route,
  Redirect
} from 'react-router-dom'
import auth from '../auth/auth.react.js';

const AuthRequiredRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => {
      if (auth.isAuthenticated()) {
        props.unauthorized = auth.signout
        const compProps = Object.assign(
          {}, props, rest
        )
        return (
          <Component {...compProps}/>
        )
      }
      return (
        <Redirect to={{
          pathname: '/login',
          state: { from: props.location }
        }}/>
      )
  }}/>
)

export default AuthRequiredRoute



// WEBPACK FOOTER //
// ./src/router/auth_required.react.js